(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gateaux-celebration-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gateaux-editorial-story')) {
    customElements.define('gateaux-editorial-story', class extends HTMLElement {
      connectedCallback() {
        this.animations = new Set();
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.stopMotion = () => {
            if (!this.motion.matches) return;
            if (this.observer) this.observer.disconnect();
            this.animations.forEach(a => a.cancel());
            this.animations.clear();
          };
          this.motion.addEventListener('change', this.stopMotion);
          if (this.dataset.motion !== 'true' || this.motion.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.observer.unobserve(entry.target);
              const animation = entry.target.animate([{opacity: .25, transform: 'translateY(20px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 650, easing: 'cubic-bezier(.2,.65,.3,1)'});
              this.animations.add(animation);
              animation.onfinish = () => this.animations.delete(animation);
            });
          }, {threshold: .12});
          this.querySelectorAll('[data-gs-reveal]').forEach(el => this.observer.observe(el));
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.motion) this.motion.removeEventListener('change', this.stopMotion);
        if (this.animations) this.animations.forEach(a => a.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gateaux-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gateaux-collection-editorial')) {
    customElements.define('gateaux-collection-editorial', class extends HTMLElement {
      connectedCallback() {
        this.animations = new Set();
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (!this.motionQuery.matches) return;
          if (this.observer) this.observer.disconnect();
          this.animations.forEach(animation => animation.cancel());
          this.animations.clear();
        };
        this.motionQuery.addEventListener('change', this.onMotionChange);
        if (this.dataset.motion !== 'true' || this.motionQuery.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        const duration = Number(this.dataset.duration) || 550;
        const stagger = Number(this.dataset.stagger) || 0;
        this.observer = new IntersectionObserver(entries => {
          let index = 0;
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            const animation = entry.target.animate(
              [{ opacity: 0.25, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration, delay: (index++ % 3) * stagger, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards' }
            );
            this.animations.add(animation);
            animation.onfinish = () => this.animations.delete(animation);
          });
        }, { threshold: 0.08 });
        this.querySelectorAll('[data-gx-card]').forEach(card => this.observer.observe(card));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.motionQuery && this.onMotionChange) this.motionQuery.removeEventListener('change', this.onMotionChange);
        if (this.animations) this.animations.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gateaux-custom-cake-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gateaux-editorial-story')) {
    customElements.define('gateaux-editorial-story', class extends HTMLElement {
      connectedCallback() {
        this.animations = new Set();
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.stopMotion = () => {
            if (!this.motion.matches) return;
            if (this.observer) this.observer.disconnect();
            this.animations.forEach(a => a.cancel());
            this.animations.clear();
          };
          this.motion.addEventListener('change', this.stopMotion);
          if (this.dataset.motion !== 'true' || this.motion.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.observer.unobserve(entry.target);
              const animation = entry.target.animate([{opacity: .25, transform: 'translateY(20px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 650, easing: 'cubic-bezier(.2,.65,.3,1)'});
              this.animations.add(animation);
              animation.onfinish = () => this.animations.delete(animation);
            });
          }, {threshold: .12});
          this.querySelectorAll('[data-gs-reveal]').forEach(el => this.observer.observe(el));
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.motion) this.motion.removeEventListener('change', this.stopMotion);
        if (this.animations) this.animations.forEach(a => a.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
